import React from "react";
import { motion } from "framer-motion";
import { useBackgroundColor } from "@tennr/frontend/context";
import "./AboutTeamMember.css";

export interface AboutTeamMemberProps {
  variant: "leadership" | "team";
  imageUrl: string;
  name: string;
  title: string;
  imageClassName?: string;
}

export const AboutTeamMember: React.FC<AboutTeamMemberProps> = ({ variant, imageUrl, name, title, imageClassName }) => {
  const { getContrastingColor } = useBackgroundColor();

  // Use the dynamic color system that's synchronized with the background
  const textColor = getContrastingColor();

  return (
    <div className={`about-team-member about-team-member--${variant}`}>
      <img
        className={`about-team-member__image ${imageClassName || ""}`}
        alt={name}
        src={imageUrl}
        loading="lazy"
        draggable={false}
      />
      <div className="about-team-member__info">
        <motion.div
          className="about-team-member__name"
          style={{ color: textColor }}
          transition={{ duration: 0.4, ease: [0.3, 1, 0.7, 1] }}
        >
          {name}
        </motion.div>
        <motion.div
          className="about-team-member__title"
          style={{ color: textColor }}
          transition={{ duration: 0.4, ease: [0.3, 1, 0.7, 1] }}
        >
          {title}
        </motion.div>
      </div>
    </div>
  );
};
